import './App.css'
import Project from './components/Project'
import Contact from './components/Contact'

import {React, useEffect} from 'react'

export function Header () {
  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    fetch('https://212.2.245.17:3010/scanned')
       .then(response => response.json())
        // .then(data => setTotalReactPackages(data.total));

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, []);
  return (


  

    <div className='bg-color-background-default text-white p-4 py-6 pb-0'>
      <p className='text-center text-5xl md:text-5xl lg:text-6xl bg-gray-300 text-black bold font-bold p-8 rounded-md	'>
        You scanned the QR on my backpack.
        <br></br><br></br>
        <div className='text-3xl'>
        Here are some random youtube videos I like.
        <br></br><br></br>
        <div className='text-sm'>
        {/* Last updated Jan 10, 2025 */}

        </div>
       <div className='text-sm'> <u>(Optional)</u>: Walk up to me and share the last video you watched. I might add it here later. I'm trying to mix up my Youtube recommendation Algorithm.</div>

        </div>
      </p>


    </div>
  )
}

const projects = [
  {
    title: ``,
    youtube: 'yD2FSwTy2lw',
    body: `
    Welcome to my webpage. :^)
    `
  },
  {
    title: ``,
    youtube: 'FykkW8EBvIg',
    body: `
    Mediaval fae animals in the woods playing musical instruments.
    `
  },
  {
    title: ``,
    youtube: 'UYKLGX9-_4Y',
    body: `
    Russians singing by a campfire.
    `
  },
  {
    title: ``,
    youtube: 'yModCU1OVHY',
    body: `
    Me when 2AM hits.
    `
  },
  {
    title: ``,
    youtube: 'ELc4vlCIUWg',
    body: `
    Funny when you look at the game this is from.
    `
  },
  {
    title: ``,
    youtube: 'Re8y99THeYE',
    body: `
    Catchy song by splicing vocals.
    `
  },

 
]

function App () {
  return (
    <>
      <Header/>
      {/* primary wrapper */}
      <Contact />

      <div className='break-words bg-color-background-default flex'>
        <div className='bg-slate-500 mx-auto p-3 gap-3 container grid grid-flow-row auto-rows-max grid-cols-1 md:grid-cols-2 lg:grid-cols-3 rounded-3xl'>
          {projects.map((post, index) => (
            <Project key={post.title + index} project={post} rank={index} />
          ))}
          {/*<Project />*/}
        </div>
      </div>

    </>
  )
}

export default App
